import Accordion from 'LuxKit/Accordion'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'

export default function ReportingAndReconciliation() {
  return (
    <Group direction="vertical" gap={8}>
      <Heading variant="heading4">Reporting and reconciliation</Heading>
      <Accordion size="large" heading="How do I access my reporting?">
        <BodyText variant="large">
          Accessing your reporting in Business Traveller is straightforward. Here's how:
        </BodyText>
        <ol>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large" weight="bold">Navigate to the Reporting Tab:</BodyText>
              <BodyText variant="large"> Log in to your admin dashboard and locate the Reporting tab. Click on it to access the reporting section.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Select Date Range:</BodyText>
              <BodyText variant="large"> Upon entering the reporting tab, a pop-up window will appear, prompting you to select the date range for your preferred report. You can choose from default ranges such as last 30 days, last 3 months, and last 12 months. Alternatively, you can customise the date range to suit your specific preferences and requirements.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Customise Date Range:</BodyText>
              <BodyText variant="large"> If the default date ranges do not meet your needs, you have the option to customise the date range. Simply adjust the start and end dates to reflect the time period you wish to analyse.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Export Report:</BodyText>
              <BodyText variant="large"> Once you have selected the desired date range, proceed to export the report. Click on the export button, and your report will be downloaded in CSV format.</BodyText>
            </li>
          </Group>
        </ol>
        <BodyText variant="large">
          If you encounter any difficulties or require further assistance with accessing reporting features, please reach out to our Customer Support team for guidance.
        </BodyText>
      </Accordion>
    </Group>
  )
}
